import { RouterUtils, Navigate, Outlet } from 'application/providers/RouterProvider';
import { StreamsCategoryParamValues } from 'application/pages/StreamPage';
import { STREAMS_STREAM_CATEGORY_BY_ID_PATH } from 'application/consts';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectAppInitialized, selectIsAuthorized } from 'application/store';

const defaultPage = RouterUtils.generatePath(STREAMS_STREAM_CATEGORY_BY_ID_PATH, {
  category: StreamsCategoryParamValues.RECOMMENDED,
});

const AnonymousRoute = () => {
  const hasAccess = useAppSelector(selectIsAuthorized);
  const isAppInitialized = useAppSelector(selectAppInitialized);

  return hasAccess && isAppInitialized ? (
    <Navigate
      to={defaultPage}
      replace
    />
  ) : (
    <Outlet />
  );
};

export default AnonymousRoute;
